import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-3"
}, null, -1);
const _hoisted_5 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12 mb-3"
};
const _hoisted_8 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_9 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_10 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_11 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_12 = {
  key: 0,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_13 = {
  class: "i-layer"
};
const _hoisted_14 = {
  class: "row"
};
const _hoisted_15 = {
  key: 0,
  class: "col-12 mb-3 mt-3"
};
const _hoisted_16 = {
  class: "fw-medium fsi-14 d-flex align-items-center justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_17 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_18 = {
  style: {
    "min-width": "100px",
    "text-align": "center"
  },
  class: "d-flex align-items-center align-content-center justify-content-start pl-3"
};
const _hoisted_19 = {
  key: 1,
  class: "col-12 mt-2"
};
const _hoisted_20 = {
  key: 2,
  class: "col-12 mb-2 mt-2"
};
const _hoisted_21 = {
  key: 3,
  class: "w-100 i-layer mb-2"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_23 = {
  key: 4,
  class: "col-12 mt-2"
};
const _hoisted_24 = {
  key: 1,
  class: "mt-2 OffBoardingStep1"
};
const _hoisted_25 = {
  class: "row"
};
const _hoisted_26 = {
  class: "col-12"
};
const _hoisted_27 = {
  class: "i-layer mb-2"
};
const _hoisted_28 = {
  key: 0,
  class: "row mb-3 mt-3"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mb-1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-18"
}, "Change Control")], -1);
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  class: "row mt-3"
};
const _hoisted_32 = {
  class: "col-12"
};
const _hoisted_33 = {
  key: 1,
  class: "row mb-3 i-layer"
};
const _hoisted_34 = {
  class: "col-12 mb-1"
};
const _hoisted_35 = {
  key: 2,
  class: "row mt-4"
};
const _hoisted_36 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_Remove = _resolveComponent("Remove");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_CirclePlus = _resolveComponent("CirclePlus");
  const _component_el_button = _resolveComponent("el-button");
  const _component_evm_err_tip = _resolveComponent("evm-err-tip");
  const _component_Tip = _resolveComponent("Tip");
  const _component_Singer = _resolveComponent("Singer");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Node')) + " f0" + _toDisplayString($props.nodeId), 1)]), _hoisted_4, _withDirectives((_openBlock(), _createElementBlock("div", null, [$data.showCurrentControl ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('change.current')) + " Control ID", 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($options.nodeInfo.controlAddresses.join(',')), 1), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_12, " copied ")) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [$data.showNewControl ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('change.new')) + " Control ID", 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newControls, (_, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "d-flex align-items-center mt-3",
      key: index
    }, [_createVNode(_component_el_input, {
      size: "large",
      class: _normalizeClass($data.newControlsIsErr[index] !== '' ? 'stake-input-err' : ''),
      disabled: $data.affirmControl,
      style: {
        "height": "50px"
      },
      onKeyup: _withKeys($options.affirm, ["enter"]),
      onInput: $event => $options.clearErr(index),
      modelValue: $data.newControls[index],
      "onUpdate:modelValue": $event => $data.newControls[index] = $event,
      placeholder: _ctx.$t('change.controlInputTip')
    }, null, 8, ["class", "disabled", "onKeyup", "onInput", "modelValue", "onUpdate:modelValue", "placeholder"]), _createElementVNode("div", _hoisted_18, [$data.newControls.length !== 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "link-text mr-3 icon-hover",
      style: {
        "transform": "translateY(3px)",
        "color": "#ee4444"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => $options.delControllId && $options.delControllId(...args))
    }, [_createVNode(_component_el_icon, {
      size: "20"
    }, {
      default: _withCtx(() => [_createVNode(_component_Remove)]),
      _: 1
    })])) : _createCommentVNode("", true), index === $data.newControls.length - 1 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "link-text icon-hover",
      style: {
        "transform": "translateY(3px)"
      },
      onClick: _cache[1] || (_cache[1] = (...args) => $options.addControllId && $options.addControllId(...args))
    }, [_createVNode(_component_el_icon, {
      size: "20"
    }, {
      default: _withCtx(() => [_createVNode(_component_CirclePlus)]),
      _: 1
    })])) : _createCommentVNode("", true)])]);
  }), 128))])) : _createCommentVNode("", true), !$data.showNewControl && !$data.affirmControl ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.reapprove,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.change')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])) : _createCommentVNode("", true), $data.isNewControllErr ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_evm_err_tip, null, {
    content: _withCtx(() => [_createTextVNode(_toDisplayString($data.newControllErrTips), 1)]),
    _: 1
  })])) : _createCommentVNode("", true), !$data.isHaveActorId ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_Tip, {
    level: "error"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Operator.Actor Not Found')), 1), _hoisted_22, _createTextVNode(" " + _toDisplayString(_ctx.$t('Operator.You should recharge this address with some FIL')), 1)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.showNewControl && !$data.affirmControl ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.affirm,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])) : _createCommentVNode("", true)])]), $data.affirmControl ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [!$data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_Singer, {
    ref: "singer",
    nodeRole: $data.nodeRole,
    singerMultiple: $data.singerMultiple,
    singerType: "approval",
    btnProposal: "Send Proposal",
    "contract-method": $data.contractMethod,
    contractParams: $data.contractParams,
    onNext: $options.approvedProposal2,
    originalSingerTables: $data.singerTables
  }, null, 8, ["nodeRole", "singerMultiple", "contract-method", "contractParams", "onNext", "originalSingerTables"])])]), !$data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.cancel')), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true), $data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createVNode(_component_AdCard2, {
    title: _ctx.$t('change.controlOk'),
    "btn-text": _ctx.$t('Onboarding.View Node'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "btn-text", "onBtnClick"])])])) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true)])), [[_directive_loading, $data.initLoading]])]);
}